import React, { memo } from 'react';
import './smrUnitCard.css';
import { Icon } from '../../../../globalUtils/globalIcons';

interface SmrUnitCardProps {
  label: string;
  serial: string | null | undefined;
  swVersion: string | null | undefined;
  hePartNumber: string | null | undefined;
}

const isEmptyValue = (value: string | null | undefined): boolean =>
  value === null || value === undefined || value.trim() === '' || value.trim() === '-' || value.trim().toLowerCase() === 'na';

const SmrUnitCard = memo(function SmrUnitCard({ label, serial, swVersion, hePartNumber }: SmrUnitCardProps) {
  const empty = isEmptyValue(serial);

  return (
    <div className={`inventory__smr__unit ${empty ? 'inventory__smr__unit--none' : ''}`}>
      <span className='inventory__smr__unit__label'>{label}</span>
      {empty ? (
        <span className='inventory__smr__unit__value inventory__smr__unit__value--none'>
          <Icon iconClassName='inventory__smr__unit__warning_icon'/>
          none
        </span>
      ) : (
        <>
        <div className='inventory__system__card__param__row'>
          <span className='inventory__smr__unit__row_label'>SERIAL NUMBER</span>
          <span className='inventory__smr__unit__value'>{serial}</span>
        </div>
        <div className='inventory__system__card__param__row'>
          <span className='inventory__smr__unit__row_label'>HE PART NUMBER</span>
          <span className='inventory__smr__unit__value'>{isEmptyValue(hePartNumber) ? '-' : hePartNumber}</span>
        </div>
        <div className='inventory__system__card__param__row'>
          <span className='inventory__smr__unit__row_label'>SW Version</span>
          <span className='inventory__smr__unit__value'>{isEmptyValue(swVersion) ? '-' : swVersion}</span>
        </div>
        </>
      )}
    </div>
  );
});

export default SmrUnitCard;
